import React, { useState, useEffect } from "react";
import {
  TableContainer,
  Table,
  Typography,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Box,
} from "@mui/material";
import { getDynamicLinksAnalytics } from "../../../api/DynamicLinks";
import Processing from "../../../components/Processing/Processing";

const PLATFORMS = ["ANDROID", "IOS", "OTHER"];

const EVENT = [
  "CLICK",
  "REDIRECT",
  "APP_INSTALL",
  "APP_FIRST_OPEN",
  "APP_RE_OPEN",
];

export const AnalyticsTable = ({ dynamicLinks }: { dynamicLinks: string }) => {
  const [isProgress, setIsProgress] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const [analytics, setAnalytics] = useState<any>({
    LinkEventStats: [],
  });

  useEffect(() => {
    if (dynamicLinks) {
      setIsProgress(true);
      setIsError(false);

      getDynamicLinksAnalytics(dynamicLinks)
        .then((response) => {
          setAnalytics(response);
        })
        .catch(() => {
          setIsError(true);
        })
        .finally(() => {
          setIsProgress(false);
        });
    }
  }, [dynamicLinks]);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: "24px",
      }}
    >
      {isError && <Typography>Internal Server Error</Typography>}
      {!isError && isProgress && (
        <Box
          sx={{
            height: "280px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Processing size={40} color="#6750A4" />
        </Box>
      )}
      {!isError && !isProgress && (
        <TableContainer sx={{ width: "auto", fontSize: "14px !important" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: "14px !important" }}> </TableCell>
                <TableCell sx={{ fontSize: "14px !important" }}>
                  CLICK
                </TableCell>
                <TableCell sx={{ fontSize: "14px !important" }}>
                  REDIRECT
                </TableCell>
                <TableCell sx={{ fontSize: "14px !important" }}>
                  APP_INSTALL
                </TableCell>
                <TableCell sx={{ fontSize: "14px !important" }}>
                  APP_FIRST_OPEN
                </TableCell>
                <TableCell sx={{ fontSize: "14px !important" }}>
                  APP_RE_OPEN
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {PLATFORMS.map((platform) => {
                const data = analytics?.LinkEventStats?.filter(
                  (obj: any) => obj.Platform === platform
                );
                return (
                  <TableRow key={platform}>
                    <TableCell sx={{ fontSize: "14px !important" }}>
                      {platform}
                    </TableCell>
                    {EVENT.map((event) => (
                      <TableCell
                        sx={{ fontSize: "14px !important" }}
                        key={`${event}${platform}`}
                        align="center"
                      >
                        {data?.filter((obj: any) => obj.Event === event)[0]
                          ?.Count ?? "0"}
                      </TableCell>
                    ))}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <Typography sx={{ mt: "10px" }} fontSize={"15px"}>
            - Note that these statistics might not include events that have been
            logged within the last 36 hours.
          </Typography>
        </TableContainer>
      )}
    </div>
  );
};

export default AnalyticsTable;
